import vn_simple_rounded from "../../../../assets/images/vn_simple_rounded.png";
import search_agent_standard from "../../../../assets/images/search_agent_standard.png";
import company_agent_standard from "../../../../assets/images/company_agent_standard.png";

export const agents = [
  {
    id: 0,
    name: "Hybrid",
    apiName: "MAIN",
    description: "Investigate information related to your mission",
  },
];

export const DEFAULT_AGENT = agents[0];

export const panelClasses = [
  "relative mx-auto w-full overflow-hidden shadow-login-panel",
  "bg-dropdownBg/95 backdrop-blur-md",
  "ring-1 ring-surfaceBorder",
].join(" ");

export const EMOJI_CATEGORIES = {
  Smileys: [
    "😀",
    "😂",
    "🥹",
    "😊",
    "😇",
    "🥰",
    "😍",
    "🤩",
    "😘",
    "😜",
    "🤪",
    "😎",
    "🤓",
    "🧐",
    "😤",
    "😭",
    "🥺",
    "😱",
    "🤯",
    "🫡",
    "🫠",
    "🤔",
    "🤫",
    "🫣",
    "😶",
    "😏",
    "😈",
  ],
  Gestures: [
    "👍",
    "👎",
    "👋",
    "🤝",
    "🙏",
    "💪",
    "🫶",
    "👏",
    "🤞",
    "✌️",
    "🤙",
    "👀",
    "🧠",
    "💀",
    "❤️",
    "🔥",
    "⭐",
    "💯",
    "✅",
    "❌",
    "⚡",
    "💡",
    "🎯",
    "🚀",
    "💰",
    "📌",
    "🔗",
  ],
  Work: [
    "📊",
    "📈",
    "📉",
    "📋",
    "📝",
    "💼",
    "🗂️",
    "📁",
    "🔍",
    "⏰",
    "📅",
    "🏆",
    "🎉",
    "🤖",
    "💻",
    "🛠️",
    "⚙️",
    "📧",
    "📞",
    "🔒",
    "🔑",
    "🏷️",
    "📎",
    "✏️",
    "🗑️",
    "📤",
    "📥",
  ],
};

// Re-export image assets so other components can import from one place
export { vn_simple_rounded, search_agent_standard, company_agent_standard };
